<template>
  <div
    class="spl-parcel-detail-block spl-detail-loading-list">
    <div class="spl-parcel-detail-block__label">
      {{ label }}
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE)"
      :class="{'spl-parcel-detail-block__edit-open': isEditing}"
      class="spl-parcel-detail-block__edit"
      @click="toggleEditable" />

    <!-- *********************** Body of the block *********************************** -->
    <div class="spl-parcel-detail-block__body">
      <!-- *********************** Block with all fields *********************************** -->
      <ul
        v-if="!isEditing"
        class="spl-parcel-detail-block__body__content">
        <li
          v-for="(loadingItem, index) in filteredLoadingList"
          :key="'detailLoadingList' + index">
          {{ loadingItem }}
        </li>
        <li v-if="(!expanded && loadingList.length > 10)">
          ...
        </li>
      </ul>
      <form-button
        v-if="!isEditing && ((!expanded && loadingList.length > 10) || expanded)"
        wide="true"
        secondary="true"
        @onClick="toggleExpand">
        Show {{ expanded ? 'less' : 'more' }}
      </form-button>

      <div v-if="isEditing" :class="{'spl-parcel-detail-block__body__content-edit': isEditing}">
        <textarea
          ref="loadingListEditor"
          v-model="parcel_json.Loading_List"
          name="loadingListEditor"
          cols="30"
          rows="10" />
      </div>

      <div v-if="isEditing" class="row">
        <div class="col6">
          <form-button
            wide="true"
            secondary="true"
            @onClick="close">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :disabled="saving"
            wide="true"
            @onClick="save">
            Save
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
import { take } from 'lodash'
export default {
  name: 'ParcelDetailBlockLoadingList',
  mixins: [Helpers],
  props: [
    'label',
    'originalParcelJson',
    'editInProgress'
  ],
  data () {
    return {
      isEditing: false,
      constants,
      tempParcelJson: this.cloneArray(this.originalParcelJson),
      saving: false,
      expanded: false
    }
  },
  computed: {
    loadingList () {
      return this.parcel_json.Loading_List.split('\n')
    },
    parcel_json () {
      return this.tempParcelJson
    },
    filteredLoadingList () {
      if (this.expanded) {
        return this.loadingList
      } else if (this.loadingList.length > 1) {
        return take(this.loadingList, 10)
      } else {
        return this.loadingList
      }
    }
  },
  methods: {
    toggleExpand () {
      this.expanded = !this.expanded
    },
    close () {
      this.isEditing = false
      window.bus.$emit('edit_in_progress')
    },

    // ************************ Toogle  Editable ************************
    // Changes to edit mode or closes it again. Edit mode is only possible if
    // not already another component is in edit mode
    toggleEditable () {
      // Close the edit mode
      if (this.isEditing) {
        this.close()
      } else {
        // Open the edit mode if not another component is in editing
        if (this.editInProgress) {
          window.bus.$emit('openWarningModal', 'You can only update one section at the same time. Please close the other one to edit here.')
        } else {
          this.isEditing = true
          window.bus.$emit('edit_in_progress')
        }
      }
    },

    // Checks which fields were updated and
    save () {
      this.saving = true
      // Check if something was changed
      this.get_Changed_Parcel(this,
        // Success function which returns if something was changed and updated parcel_json
        function (context, parcelUpdated, tempParcelJson) {
          // Check if an update happend
          if (parcelUpdated) {
            // call update parcel web API
            // Call the api and pass the filtered columns and values
            webApi.parcel.update_Parcel(tempParcelJson).then((response) => {
              // Parcel was succesfully updated so we update the blockContent
              context.$toast('The parcel got updated with your changes', constants.defaultToastOptions())
              context.$emit('parcelUpdated')
              context.isEditing = false
              context.saving = false
              window.bus.$emit('edit_in_progress')
            }).catch((response) => {
              window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
              context.saving = false
            })
            // update the modal with the new information
          } else {
            // Nothing was changed, so throw a warning
            window.bus.$emit('openWarningModal', "Didn't you forget something? Nothing was changed.")
            context.saving = false
          }
        },
        function () {
          window.bus.$emit('openErrorModal', 'Please try again.')
        })
    },

    // Checks if something was changed  in the block and returns updated parcel_json
    get_Changed_Parcel (context, successFunction, errorFunction) {
      // Copy the parcel
      var tempParcelJson = context.cloneArray(this.originalParcelJson)
      // Loop the content to get all changed fields
      let parcelUpdated = false
      if (tempParcelJson.Loading_List !== this.parcel_json.Loading_List) {
        parcelUpdated = true
        tempParcelJson.Loading_List = this.parcel_json.Loading_List.replace(/\r?\n/g, '\r\n')
      }
      // Return the succes function
      successFunction(context, parcelUpdated, tempParcelJson)
    }

  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-detail-loading-list {
      .spl-parcel-detail-block__body__content-edit {
        margin-bottom: 20px;
      }
    }
</style>
